import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../config/config';
import Fetch from "../../../../core/util/core/Fetch";
import { chooseProfileFilter } from "../../../helpers/chooseProfileFilter";

function Form() {
    const [form, setForm] = useState();
    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const { id } = useParams();

    const profileFilter = chooseProfileFilter()

    const hiddenValues = {}

    const path = '/processes/';
    const paths = {
        endpointSave: config.endpoints.backend + 'processes/save',
        endpointGetById: config.endpoints.backend + 'processes/getById',
        endpointGetByProcessNumber: config.endpoints.backend + 'processes/getByProcessNumber',
        endpointGetAllProcessTypes: config.endpoints.backend + 'processtypes/getall',
        endpointGetAllProjects: config.endpoints.backend + 'projects/getall',

        urlGoBack: path + 'list',
        pathView: path + 'view'
    }

    const labels = {
        labelTitleAdd: "Novo Processo",
        labelTitleEdit: "Editar Processo",
        labelTitleView: 'Visualizar Processo'
    }

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            hiddenValues: {
                ...hiddenValues
            },
            fields: [
                {
                    name: 'pdc_project_id',
                    type: 'select',
                    label: 'Projeto',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllProjects,
                        label: 'project_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                },
                {
                    name: 'process_number',
                    type: 'text',
                    mask: '999999/9999',
                    label: 'Número do Processo',
                    validations: {
                        required: true,
                        process_number: true
                    },
                    columnSize: 12
                },
                {
                    name: 'pdc_process_type_id',
                    type: 'select',
                    label: 'Tipo de Processo',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllProcessTypes,
                        label: 'name',
                        value: 'id'
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                },
                {
                    name: 'opening_date',
                    type: 'date',
                    label: 'Data de Abertura',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'object',
                    type: 'textarea',
                    label: 'Objeto',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                }
            ],
            customValidators: {
                process_number: (value, options, key, attributes) => {
                    const checkProcessNumber = async (value) => {
                        const mask = /^\d{6}\/\d{4}$/
                        if (mask.test(value)) {
                            if (attributes.pdc_project_id) {
                                const post = {
                                    process_number: value,
                                    pdc_project_id: attributes.pdc_project_id
                                };

                                const processes = await Fetch.post(paths.endpointGetByProcessNumber, post);

                                if (processes.id && processes.id != id) {
                                    return '^O número do processo já existe';
                                }
                            }
                        }else{
                            return "^O formato deve ser 000000/0000 (Número/Ano)";
                        }
                    }
                    return checkProcessNumber(value);
                }
            },
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};
            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }
            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
